import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import "../styles/Dashboard.css";

import UserComponent from "../components/UserComponent/UserComponent";

import SchedualerComponent from "../components/SchedualerComponent/SchedualerComponent";
import { ICONS } from "../constants/constants";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { handleGetFarmerTasksList } from "../store/actions/farmerTasksActions"; // Import your action
import {
  handleGetFarmerFarmDetails,
  handleGetFarmerOrders,
  handleGetFarmerDetails
} from "../store/actions/farmersActions";
//import { getFarmerTasksSuccess } from "../store/slices/farmerTasksSlice";
import TableComponent from "../components/TableComponent/TableComponent";
import Loader from "../assets/images/loader.gif";

const Farmer = () => {
  const { id } = useParams();
  const userId = id;

  const dispatch = useDispatch();
  useEffect(() => {
   
 
    dispatch(handleGetFarmerTasksList(userId));

    dispatch(handleGetFarmerDetails(userId));
    handleGetFarmerFarmDetails(dispatch, userId);
    handleGetFarmerOrders(dispatch, userId);
  }, [dispatch, userId]);

  

  // const farmerTasksState = useSelector((state) => state.FarmerTasks || {});
  // const { farmerTasks = [], isLoading = false } = farmerTasksState;
  const { tasksList, isLoading } = useSelector((state) => state.assignedtasks || {});
  const  farmerTasks = tasksList;


  const { farmerFarmDetails } = useSelector((state) => state.farmer);
  const { farmerDetails = {} } = useSelector((state) => state.farmer || {});


  const { farmerOrders } = useSelector((state) => state.farmer);
  const { user: currentUser } = useSelector((state) => state.user);
  useEffect(() => {
    // Dispatch the action to fetch farm details
    if (userId) {
      dispatch(handleGetFarmerFarmDetails(userId));
    }
  }, [userId, dispatch]);
  useEffect(() => {
    // Dispatch the action to fetch farm details
    if (userId) {
      dispatch(handleGetFarmerOrders(userId));
    }
  }, [userId, dispatch]);

  if (isLoading) {
    return (
      <div className="loaderOverlay">
        <img src={Loader} alt="Loader" />
      </div>
    );
  }

  if (!farmerFarmDetails || Object.keys(farmerFarmDetails).length === 0) {
    return <div>No Farm Details Available</div>;
  }

  const tableTitle = "Orders";
  const columns = [
    "OrderID",
    "Supplier",
    "Farmer",
    "ProductNumber",
    "OrderStatus",
    ...(currentUser?.role !== "manager" ? ["TotalAmount"] : []),
    "Actions",
  ];
  
  const effectiveColumns = currentUser?.role === "manager" ? columns.filter((c) => c !== "TotalAmount") : columns;
// console.log('farmerOrders', farmerOrders);
  const data = farmerOrders?.orders?.map((order) => {
    const actionsContent =
      order?.order_status === "Confirm" ? (
        <>
          <Link
            to={`/order-details/${order.id}`}
            state={{ order }}
            rel="noopener noreferrer"
          >
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          <img src={ICONS.downloadIcon} alt="Download" className="cross-icon" />
        </>
      ) : (
        <>
          <Link
            to={`/order-details/${order.id}`}
            state={{ order }}
            rel="noopener noreferrer"
          >
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          <img src={ICONS.downloadIcon} alt="Download" className="cross-icon" />
        </>
      );

    const row = {
      OrderID: order.id || "N/A",
      Supplier: order?.supplierUser?.name || "N/A",
      Farmer: order?.farmerUser?.name || "N/A",
      ProductNumber: order?.orderItems?.length || 0,
      OrderStatus: order.order_status || "N/A",
      Actions: actionsContent,
    };

    if (currentUser?.role !== "manager") {
      row.TotalAmount = order.totalCost || "N/A";
    }

    return row;
  });

  // Pass dynamically if these features should be shown
  const showSearchBar = true; // Change to false to hide search bar
  const searchplaceholder = "Search by ID, Order By,Order Placed";
  const showFilter = false; // Change to false to hide filter
  const showTabs = true; // Change to false to hide tabs (Approved/Not Approved)
  const showColors = false;

  // const renderFarmerTasks = () => {
  //   return farmerTasks?.map((task, index) => (
  //     <tr key={index}>
  //       <td>{task.taskId}</td>
  //       <td>{task.taskName}</td>
  //       <td>{task.status}</td>
  //       <td>{task.assignedDate}</td>
  //     </tr>
  //   ));
  // };
  const farmerConsultants =
  farmerDetails?.data?.farmer?.farmerConsultants || [];

const latestConsultant = farmerConsultants
  .filter(fc => fc?.consultantUser) // ignore null consultants
  .sort(
    (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
  )[0];
  const userData = {
    id: farmerDetails?.data?.farmer?.id,
    name: farmerDetails?.data?.farmer?.name,
    userdatarole: farmerDetails?.data?.farmer?.role,
     company: farmerDetails?.data?.farmer?.company?.name || "N/A",
    account_status: farmerDetails?.data?.farmer?.account_status,
    otp_status: farmerDetails?.data?.farmer?.otp_status,
    consultant: latestConsultant?.consultantUser?.name || "No Consultant Assigned",

    joinedDate: farmerDetails?.data?.farmer?.created_at,
    cnicImages: Array.isArray(farmerDetails?.data?.farmer?.farmDetails)
      ? farmerDetails.data.farmer.farmDetails.flatMap((farm) => farm.cnic || [])
      : [],
    farmDetails: farmerDetails?.data?.farmer?.farmDetails?.[0] || null,
    latitude: farmerDetails?.data?.farmer?.latitude,
    longitude: farmerDetails?.data?.farmer?.longitude
  };


  // Access the documents of the 4th farm item
  const documents = userData?.farmDetails
    ? {
        farmPhotos: userData?.farmDetails?.farm_photos?.map((photo) => ({
          title: "Farm Photo", // You can customize the title
          link: photo,
        })),
        leaseDocuments: userData?.farmDetails?.land_lease_documents?.map((doc) => ({
          title: "Land Lease Document", // You can customize the title
          link: doc,
        })),
        soilTypeDocuments: userData?.farmDetails?.soil_type_documents?.map(
          (doc) => ({
            title: "Soil Type Document", // You can customize the title
            link: doc,
          })
        ),
        waterTypeDocuments: userData?.farmDetails?.water_type_documents?.map(
          (doc) => ({
            title: "Water Type Document", // You can customize the title
            link: doc,
          })
        ),
      }
    : {};

  const userDetailsArray = [
    { label: "Name", value: farmerDetails?.data?.farmer?.name },
    // { label: "Email", value: farmer?.email },
    { label: "CNIC/NTN", value: farmerDetails?.data?.farmer?.cnic },
    { label: "Mobile Number", value: farmerDetails?.data?.farmer?.mobile_number },
    ...(currentUser?.role !== "manager"
      ? [
          {
            label: "Consultant",
            value: latestConsultant?.consultantUser?.name || "No Consultant Assigned",
          },
        ]
      : []),
    { label: "City", value: farmerDetails?.data?.farmer?.city },
    { label: "Address", value: farmerDetails?.data?.farmer?.address },
     { label: "Company", value: farmerDetails?.data?.farmer?.company?.name || "N/A" },
    { label: "Geo Location", value: farmerDetails?.data?.farmer?.city },
    // { label: "Soil Type", value: supplier?.company },
    // { label: "Water Type", value: supplier?.company },
  ];

  const farmerCropSchedualer = farmerDetails?.data?.farmer?.farmDetails?.[0]?.farmerCrops;
  const activeFarmerCrops = farmerCropSchedualer?.filter(crop => crop.status === "Active") || [];
  const farmerSchedualer = activeFarmerCrops[0]?.crop?.schedualer?.tasks || activeFarmerCrops[0]?.crop?.farmerTasks;
  // const farmerAssignedTasks = activeFarmerCrops[0]?.crop?.farmerTasks;
  // const currentFarmerCrop = activeFarmerCrops[0]?.crop?.cropName;
//console.log('farmerSchedualer', activeFarmerCrops, farmerSchedualer);
  return (
    <Container>
      <Row>
        <Col lg={12} className="breadcrum-container ">
          <Row className="breadcrum-container  py-3">
            <Col lg={12}>
              <div className="custom-breadcrumb">
                {/* <span><a href="/">Home</a></span> */}
                <img src={ICONS.farmer} className="icon" alt="farmer-icon" />
                <span>
                  <a href="/farmers">Farmers</a>
                </span>
                <span>
                  {userData.name}
                  {/* ({userData.id}) */}
                </span>
              </div>
            </Col>
          </Row>
        </Col>
        <Col lg={12} className="component-container mb-2">
          <UserComponent
            user={userData}
            userDetails={userDetailsArray}
            documents={documents}
          />
          
        </Col>
      </Row>
      {userData.account_status === "Approved" && (
        <Row>
          <Col lg={12} className="component-container mb-2">
            <SchedualerComponent
              schedualer={farmerSchedualer}
              farmerTasks={farmerTasks}
              isLoading={isLoading}
            />
          </Col>
          <Col lg={12} className="component-container mb-2">
            <TableComponent
              columns={columns}
              data={data}
              title={tableTitle}
              showSearchBar={showSearchBar}
              searchplaceholder={searchplaceholder}
              showFilter={showFilter}
              showTabs={showTabs}
              showColors={showColors}
            />
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default Farmer;
